import { MessageBox, Notification } from 'element-ui'
const Config = process.env
// 验证登录
export const checkLogin = true

// 常量
export const CONST = {
  needLogin: 'needLogin', // 鉴权失败，需要重新登录
  noRouteAuth: 'noRouteAuth', // 鉴权失败，没有路由权限
  initError: 'initError' // 初始化异常
}

export async function errorHandler(type, message) {
  switch (type) {
    case CONST.needLogin:
      login()
      break
    case CONST.noRouteAuth:
      await MessageBox.alert(message, '注意', { showClose: false })
      window.location.reload()
      break
    case CONST.initError:
      await MessageBox.alert('检测到页面可能初始化异常，请刷新重试！', '注意', { showClose: false })
      window.location.reload()
      break
  }
}

export function login() {
  window.location.replace(`${Config.VUE_APP_SSO}?url=${encodeURIComponent(window.location.href)}`)
}

export function logout() {
  window.location.replace(`${Config.VUE_APP_SSO}?url=${encodeURIComponent(window.location.href)}&action=logout`)
}
